export default {"src":"/_next/static/media/how-to-choose-grid-size.53e277ad.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};